
<collapsible-pane title="{{ 'Pre set variables:' | translate }}" class="mb-3 d-block collapsible-box-draggable">
    <list-group-item dnd-draggable
                     [dndDraggable]="{ 'name': 'numericValue', 'value': 0 }" [dndEffectAllowed]="effectAllowed" style="width:100%;">
        <div class="list-group-item-content">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
                    <span class="font-09">
                      {{ 'Numerical input' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </list-group-item>
    <list-group-item dnd-draggable
                     [dndDraggable]="{ 'name': 'textValue', 'value': '' }" [dndEffectAllowed]="effectAllowed" style="width:100%;">
        <div class="list-group-item-content">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
                    <span class="font-09">
                      {{ 'Text input' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </list-group-item>
    <list-group-item dnd-draggable
                     [dndDraggable]="{ 'name': 'dateValue', 'value': currentDate }" [dndEffectAllowed]="effectAllowed" style="width:100%;">
        <div class="list-group-item-content">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
                    <span class="font-09">
                      {{ 'Date input' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </list-group-item>
    <list-group-item dnd-draggable
                     [dndDraggable]="{ 'name': 'dateToday', 'value': 'dateToday', 'label': 'Today' }" [dndEffectAllowed]="effectAllowed" style="width:100%;">
        <div class="list-group-item-content">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
                    <span class="font-09">
                      {{ "Today's date" | translate }}
                    </span>
                </div>
            </div>
        </div>
    </list-group-item>
</collapsible-pane>

<!-- Form fields filter -->
<collapsible-pane title="{{ 'All Form fields:' | translate }}" class="mb-3 d-block collapsible-box-draggable max-height-group" *ngIf="formFieldsFilter.length > 0">
    <list-group-item *ngFor="let item of formFieldsFilter" style="width:100%;"
                     [isEnum]="isEnum(item)"
                     [selections]="item.selections"
                     [hidden]="isHidden(item)"
                     [catalogIds]="catalogIds">
        <div class="list-group-item-content"
             dnd-draggable
             [dndDraggable]="initDraggable(item)"
             [dndEffectAllowed]="effectAllowed">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
                  <span class="font-09">
                      {{stripHtml(item.title)}}
                  </span>
                </div>
            </div>
        </div>
    </list-group-item>
</collapsible-pane>

<collapsible-pane title="{{ 'Form fields:' | translate }}" class="mb-3 d-block collapsible-box-draggable max-height-group" *ngIf="formFields.length > 0">
    <list-group-item *ngFor="let item of formFields" style="width:100%;"
                     [isEnum]="isEnum(item)"
                     [selections]="item.selections"
                     [hidden]="isHidden(item)"
                     [catalogIds]="catalogIds">
        <div class="list-group-item-content"
             dnd-draggable
             [dndDraggable]="{'label': stripHtml(item.title), 'value': idFromTitle(item.title, item.id), 'name': stripHtml(item.title), 'id': item.id, 'type': item.type, options: item.selections}"
             [dndEffectAllowed]="effectAllowed">
            <div style="width:80%">
                <div style="display: flex; align-items: center">
                  <span class="font-09">
                      {{stripHtml(item.title)}}
                  </span>
                </div>
            </div>
        </div>
    </list-group-item>
</collapsible-pane>
<collapsible-pane title="{{ 'Groups:' | translate }}" *ngIf="isDeterminant && groups.length">
    <list-group-item *ngFor="let item of groups" [hidden]="!(catalogIds.value.includes(item.classificationTypeId))">
        <div class="list-group-item-content" dnd-draggable
             [dndDraggable]="{'label': stripHtml(item.name), 'value': idFromTitle(item.name, item.id), 'name': stripHtml(item.name), 'id': item.id, 'type': 'token', 'items': item.items}"
             [dndEffectAllowed]="effectAllowed">
            <div>
                <div style="display: flex; align-items: center">
                  <span class="font-09">
                      {{stripHtml(item.name)}}
                  </span>
                </div>
            </div>
        </div>
    </list-group-item>
</collapsible-pane>
<collapsible-pane *ngIf="systemFields.length" title="{{ 'Data provided automatically by system:' | translate }}" class="mb-3 d-block collapsible-box-draggable">
    <list-group-item *ngFor="let item of systemFields" style="width:100%;"
                     [isEnum]="isEnum(item)"
                     [selections]="item.selections"
                     [guide]="item"
                     [hidden]="isHidden(item)"
                     [catalogIds]="catalogIds">
        <div class="list-group-item-content"
             dnd-draggable
             [dndDraggable]="{'label': item.name, 'value': item.key, 'name': item.name, 'id': item.key, 'type': item.type, options: item.selections}"
             [dndEffectAllowed]="effectAllowed">
            <div>
                <div style="display: flex; align-items: center">
                  <span class="font-09">
                      {{item.name}}
                  </span>
                </div>
            </div>
        </div>
    </list-group-item>
</collapsible-pane>


